import { ToastrModule, ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { AppService } from '../core/services/app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../core/services/auth.service';
import { LoginRequest } from '../core/interfaces/usuario';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  formPassword: FormGroup;
  formLogin: FormGroup;
  errorMessage: string;
  login: LoginRequest = {
    login: '',
    senha: ''
  };
  check = true;
  visiblePass = false;
  visiblePassBtn = false;
  loading = false;
  isClickOnLogin = false;
  tipoDeUsuario: string[] = [];
  inputVisibleType: 'text' | 'password' = 'password';
  placeholderText: string = '*****';


  constructor(
    protected app: AppService,
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private toastrService: ToastrService,
  ) { }

  ngOnInit() {
    this.formLogin = this.formBuilder.group({
      login: ['', Validators.required],
      senha: ['', Validators.required]
    });
    this.formPassword = this.formBuilder.group({
      email: ['', Validators.required]
    });
    const redirectTo = this.activatedRoute.snapshot.queryParams.redirect;
    if (redirectTo) {
      this.loading = true;
      this.toLogin();
    }
  }


  showPasswordInField() {
    if (this.inputVisibleType == 'text') {
      this.inputVisibleType = 'password';
      this.placeholderText = '*****';
    } else {
      this.inputVisibleType = 'text';
      this.placeholderText = 'Senha';
    }
  }

  async toLogin(event?) {
    if (event) {
      event.preventDefault();
    }
    const form = this.formLogin.value;
    this.formPassword.disable();
    this.isClickOnLogin = true;
    this.loading = true;

    if (form.login === '' || form.senha === '') {
      this.formPassword.enable();
      this.loading = false;
      return this.toastrService.warning('E-mail ou senha inválidos, corrija e tente novamente.');
    }

    this.authService.login(form).then(
      async (resultado: any) => {

        const { accessToken, usuarioToken } = resultado.data;

        usuarioToken.claims.map(async usuario => {
          this.tipoDeUsuario.push(usuario.value);
        })

        /**
         *
         *  Se tiver um SUPERADMIN acesso total e
         *  na tela de administrador lista os condominios
         *
         */

        await this.authService.getUserId(usuarioToken.id).then((result: any) => {
          const userData = {
            accessToken,
            ...result
          }

          localStorage.setItem('last_login_user', JSON.stringify(userData));
        });

        if (this.tipoDeUsuario.includes('SUPERADMIN')) {
          this.toastrService.success('Autenticado com sucesso. Preparando tudo, você será redirecionado em breve.');
          this.loading = false;
          return this.router.navigateByUrl('/dashboard');
        }

        this.formPassword.enable();
        this.isClickOnLogin = false;
        this.loading = false;
        return this.toastrService.warning('Você não tem permissão para acessar essa plataforma!');

      },
    ).catch((erro: HttpErrorResponse) => {
      this.loading = false;
      this.isClickOnLogin = false;

      this.app.tratarErro(erro, 'Não foi possível entrar. Tente novamente.');
    });
  }

  async forgot(event) {
    if (event) {
      event.preventDefault();
    }
    const forgot = this.formPassword.value;
    this.formPassword.disable();
    this.loading = true;

    const response = await this.authService.forgotPassword(forgot.email);
    if (response.status === 0) {
      this.loading = false;
      this.formPassword.enable();
      this.formPassword.reset();
      return this.app.alert(response.mensagem);
    }

    this.formPassword.enable();
    this.loading = false;
    return this.app.alert(response.mensagem);

  }
}
